import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiResult} from '../../../shared/model/Index';
import { ITransactionLog } from '../model/transactionlog';


@Injectable({ providedIn: 'root' })

export class TransactionLogService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    getTransactionLogById(id:string) {
        return this.http.get<ApiResult<ITransactionLog[]>>(env.apiUrl + 'transactionlog/' + id).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
}